export default [
  {
    path: 'installment-orders',
    name: 'list-debt-installment-order',
    component: () => import('./List.vue'),
    meta: {
      title: 'Công nợ quẹt thẻ đơn hàng - Clickbuy',
    },
  },
];
